import React, { useMemo, Fragment } from 'react';
import classNames from 'classnames';
import { Button } from '@osui/ui';
import { prefixCls } from '../../utils';
import './Footer.less';
import { Submit } from './Submit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const useFooterChildren = (props, other) => {
  const [disabledNext, setDisabledNext] = React.useState(false);
  const children = /*#__PURE__*/React.isValidElement(props.children) ? /*#__PURE__*/React.cloneElement(props.children, { ...other,
    disabledNext,
    setDisabledNext
  }) : props.children;
  return {
    children,
    disabledNext
  };
};
export function FooterWrapper({
  prefixCls,
  fixed,
  className,
  offset,
  align,
  children,
  left
}) {
  const style = useMemo(() => {
    const offsetValue = `${parseInt(`${offset || 0}`, 10)}px`;
    const isLt1280 = window.innerWidth > 1280;
    const baseOffset = isLt1280 ? '50vw' : '640px';

    if (align === 'right') {
      // 计算规则： 屏幕的一半 - 导航栏的宽度的一半 - 表单的一半
      return fixed ? {
        paddingRight: `calc(${baseOffset} - 490px + ${offsetValue})`,
        paddingLeft: `calc(${baseOffset} - 490px + ${offsetValue})`,
        justifyContent: 'flex-end'
      } : {};
    }

    if (left !== 0) {
      return {
        paddingLeft: left
      };
    }

    return fixed ? {
      paddingLeft: `calc(${baseOffset} - 369px + ${offsetValue})`,
      justifyContent: 'flex-start'
    } : {};
  }, [fixed, left, offset, align]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames({
        'footer-fixed-placeholder': fixed,
        'has-children': !!children
      })
    }), /*#__PURE__*/_jsx("div", {
      style: style,
      className: classNames(`${prefixCls}-footer`, {
        'is-footer-fixed': fixed,
        'has-children': !!children
      }, className),
      children: children
    })]
  });
}
FooterWrapper.displayName = "FooterWrapper";
FooterWrapper.defaultProps = {
  prefixCls
};
export function Footer(props) {
  const {
    prefixCls,
    onCancel,
    onSubmit,
    submitting,
    okText,
    cancelText,
    children: childrenIn,
    hasCancelButton,
    disabled,
    buttonSize,
    ...rest
  } = props;
  const {
    children,
    disabledNext
  } = useFooterChildren(props);
  return /*#__PURE__*/_jsx(FooterWrapper, {
    prefixCls: prefixCls,
    ...rest,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [children, /*#__PURE__*/_jsx(Submit, {
        size: buttonSize,
        disabled: disabled == null ? disabledNext : disabled,
        children: okText
      }), hasCancelButton && /*#__PURE__*/_jsx(Button, {
        type: "default",
        size: buttonSize,
        onClick: onCancel,
        className: `${prefixCls}-cancel`,
        children: cancelText
      })]
    })
  });
}
Footer.displayName = "Footer";
Footer.defaultProps = {
  /** 类名前缀 */
  prefixCls,
  fixed: true,
  className: '',
  offset: 0,
  left: 0,
  okText: '完成',
  cancelText: '取消',
  align: 'left',
  hasCancelButton: true,
  disabled: false,
  buttonSize: 'large'
};
export default Footer;
//# sourceMappingURL=es/Other/Submit/Footer.js.map